/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Empty_SystemInputs */

const en_notifications_empty_system = /** @type {(inputs: Notifications_Empty_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No system notifications.`)
};

const pt_br2_notifications_empty_system = /** @type {(inputs: Notifications_Empty_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma notificação do sistema.`)
};

/**
* | output |
* | --- |
* | "No system notifications." |
*
* @param {Notifications_Empty_SystemInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_empty_system = /** @type {((inputs?: Notifications_Empty_SystemInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Empty_SystemInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_empty_system(inputs)
	return pt_br2_notifications_empty_system(inputs)
});